import ScanConfigurationActions from './ScanConfigurationActions';

export default ScanConfigurationActions;
